var keyPressHelper = function keyPressHelper(callback) {
  return function (e) {
    if (callback && (e.key === 'Enter' || e.key === 'Spacebar' || e.key === ' ')) {
      e.preventDefault();
      for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }
      return callback.apply(void 0, args);
    }
    return undefined;
  };
};
export { keyPressHelper };